import { Component, Input, OnInit, EventEmitter, Output } from "@angular/core";
import { FlowTemplate, State, Page, Button, ButtonKind, ButtonPosition } from "../../../common/models/flow.dto";
import { genId } from "../../../core/services/genId";

@Component({
    selector: "state-builder-page-buttons",
    templateUrl: "./state-builder-page-buttons.component.html",
    styleUrls: ['./state-builder-page-buttons.component.scss'],
    standalone: false
})

export class StateBuilderPageButtonsComponent implements OnInit {

    @Input() template: FlowTemplate;
    @Input() state: State;
    @Input() page: Page;
    @Output() showRulesEvent = new EventEmitter<Button>();
    btnError: string = "";
    leftButtonOptions = [{ id: "unset", text: "--Select Action--" }, { id: "back", text: "Previous Page" }, { id: "jump", text: "Skip to Page" }, { id: "jumpSection", text: "Skip to Section" }, { id: "transition", text: "Define Transitions" }];
    rightButtonOptions = [{ id: "unset", text: "--Select Action--" }, { id: "next", text: "Next Page" }, { id: "jump", text: "Skip to Page" }, { id: "jumpSection", text: "Skip to Section" }, { id: "transition", text: "Define Transitions" }];

  
    //rightButtonOptions = [{ id: "unset", text: "--Select Action--" }, { id: "next", text: "Next Page" }, { id: "jump", text: "Skip to Page" }, { id: "adhoc", text: "Add Reviewer" }, { id: "jumpSection", text: "Skip to Section" }, { id: "transition", text: "Define Transitions" }];
    //specialButtonOptions = [{ id: "unset", text: "--Select Action--" }, { id: "adhoc", text: "Add Reviewer" }, { id: "jump", text: "Skip to Page" }, { id: "return", text: "Return" }, { id: "approve", text: "Approve" }, { id: "transition", text: "Define Transitions" }];
    specialButtonOptions = [{ id: "unset", text: "--Select Action--" }, { id: "jump", text: "Skip to Page" }, { id: "return", text: "Return" }, { id: "approve", text: "Approve" }, { id: "transition", text: "Define Transitions" }];

    disableReason: string = "Type editor disabled to maintain transitions.";
    buttonPositions: ButtonPosition[] = [ButtonPosition.Left, ButtonPosition.Right, ButtonPosition.Special];
    selectedButtonType: ButtonPosition = ButtonPosition.Left;

    ngOnInit() {
    }

    selectButtonType(buttonPosition: ButtonPosition): void {
        this.selectedButtonType = buttonPosition;
    }

    addButton(selectedType: ButtonPosition): void {
        const newButton: Button = {
            id: genId(),
            position: selectedType,
            label: 'unset',
            type: ButtonKind.Unset,
            disableTypeChange: true,
            special: selectedType == ButtonPosition.Special
        };
        this.page.buttons.push(newButton);
    }

    deleteButton(id: string): void {
        this.page.buttons = this.page.buttons.filter(x => x.id != id);
    }

    showRulesEditor(buttonId: string): void {
        let button: Button | null = null;
        button = this.page.buttons.find(b => b.id === buttonId);
        if (button !== undefined && button !== null) {
            this.showRulesEvent.emit(button);
        }
    }

    positionChanged(button: Button, newValue: string): void {
        button.position = newValue as ButtonPosition;
        button.special = (button.position == ButtonPosition.Special);
        if (!this.getButtonOptions(button).find(x => x.id === button.type)) 
            button.type = ButtonKind.Unset;
    }

    getButtonOptions(button: Button): any[] {
        switch (button.position) {
            case ButtonPosition.Left:
                return this.leftButtonOptions;
            case ButtonPosition.Right:
                return this.rightButtonOptions;
            case ButtonPosition.Special:
                return this.specialButtonOptions;
        }

        return [];
    }

    ruleRequired(button: Button): boolean {
        return ((button.type === ButtonKind.JumpToPage && !button.targetPageRule) || (button.type === ButtonKind.Transition && !button.targetTransitionRule));
    }
}